<template>
	<div class="divcreateorder">
		<createordercompose ref="createordercompose" v-show="type == 'yuu'" :l_id="l_id" :item="item"></createordercompose>
		<createorder_compose_all ref="createorder_compose_all" v-show="type == 'rateall'"></createorder_compose_all>
	</div>
</template>
<script>
import createordercompose from '@/components/order/createorder_compose.vue';
import createorder_compose_all from '@/components/order/createorder_compose_all.vue';
export default {
	components: {
		createordercompose,
		createorder_compose_all
	},
	props: {
		urlparam: {
			type: Object,
			default: {}
		},
		item:{
			type: Object,
			default:function(){
				return {
					
				};
			}
		}
	},
	data() {
		return {
			pageparam: {},
			curpkval: '',
			iscopy: 0,
			type: '',
			orderinfo:{},
			l_id:'',
			handleitem:{},
			tbpostfix:''
		};
	},
	created() {
		debugger
		if(this.item.l_tabevent!=''&&this.item.l_tabevent!=undefined)
			this.l_id=this.item.l_tabevent;
		else
			this.l_id=this.item.l_id;
	},
	mounted() {
		debugger
		if (this.urlparam != undefined) {
			if (this.urlparam.iscopy != undefined) {
				this.iscopy = this.urlparam.iscopy;
			}
			if(this.item.l_id!=undefined){
				if(this.item.l_tablename!=undefined)
					this.type=this.item.l_tablename;
					
				if(this.item.row!=undefined){
					this.curpkval = this.item.row.p_pkval;
					this.tbpostfix=this.item.row.tbpostfix;
				}
				if(this.item.iscopy!=undefined)
					this.iscopy=this.item.iscopy;
			}else{
				this.pageparam = this.urlparam;
				if (this.urlparam.pkval != undefined) {
					this.curpkval = this.urlparam.pkval;
				}
				if(this.urlparam.orderinfo!=undefined)
					this.orderinfo=this.urlparam.orderinfo;
				if(this.urlparam.l_tablename!=undefined)
					this.type=this.urlparam.l_tablename;
			}
			//console.log('type',this.type);
			if (this.type == 'yuu') {
				if (this.$refs.createordercompose != undefined) {
					this.$refs.createordercompose.init({pkval:this.curpkval,iscopy:this.iscopy,orderinfo:this.orderinfo,tbpostfix:this.tbpostfix});
				}
			}
			else if (this.type == 'rateall') {
				if (this.$refs.createorder_compose_all != undefined) {
					this.$refs.createorder_compose_all.init({pkval:this.curpkval,iscopy:this.iscopy,orderinfo:this.orderinfo});
				}
			}
		}
	}
};
</script>
